// // api.js
// import axios from 'axios';

// const api = axios.create({
//   baseURL: 'https://api.stdl.site/api',
// });

// // Attach token automatically
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem('token');

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   return config;
// });

// export default api;


// import axios from 'axios';
// //
// const api = axios.create({
//   baseURL: 'http://localhost:3001/api',
// });

// // ✅ Attach token
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem('token');

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   return config;
// });

// // 🔥 AUTO LOGOUT WHEN TOKEN FAILS
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       console.log("Token expired or invalid → logging out");

//       localStorage.removeItem('token');
//       localStorage.removeItem('user');

//       // redirect to login
//       window.location.href = '/';
//     }

//     return Promise.reject(error);
//   }
// );

// export default api;

// import axios from "axios";

// const api = axios.create({
//   baseURL: "http://localhost:3001/api",
// });

// const clearAuthStorage = () => {
//   localStorage.removeItem("token");
//   localStorage.removeItem("user");
//   localStorage.removeItem("session_expires_at");
// };

// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   const expiresAt = localStorage.getItem("session_expires_at");

//   if (expiresAt && Date.now() > Number(expiresAt)) {
//     clearAuthStorage();
//     window.location.href = "/";
//     return Promise.reject(new Error("Session expired"));
//   }

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   return config;
// });

// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       console.log("Token expired or invalid → logging out");
//       clearAuthStorage();
//       window.location.href = "/";
//     }

//     return Promise.reject(error);
//   }
// );

// export default api;





import axios from "axios";

const api = axios.create({
  baseURL: "https://api.stdl.site/api",
});

const clearAuthStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  // We don't need session_expires_at anymore!
};

// 1. Attach the token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 2. ONLY log the user out if the backend rejects the token
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log("Backend rejected token (Expired/Invalid) → Logging out");
      clearAuthStorage();
      window.location.href = "/"; // Force redirect to login
    }
    return Promise.reject(error);
  }
);

export default api;